import { initialState, CityStoresState } from './selectors';
import * as actions from './actions';

export default (
  state: CityStoresState = initialState,
  action: actions.StoresAction,
) => {
  switch (action.type) {
    case actions.CITY_STORES_ACTIONS.REQUESTED: {
      return { ...state, loading: true };
    }

    case actions.CITY_STORES_ACTIONS.SUCCEEDED: {
      const {
        payload: { stores, city },
      } = action as actions.StoresSucceeded;
      return { ...state, stores, loading: false, openCity: city };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/scenes/CityStores/services/reducer.ts